export const CHROME_TAB_TITLE = 'CHROME_TAB_TITLE'
export const CHROME_TAB_EDITOR = 'CHROME_TAB_EDITOR'



/** WEBPACK FOOTER **
 ** ./studio/constants.js
 **/